import { isNativePlatform } from '@lib/platform';

/**
 * Trigger a light haptic impact.
 * - Native (Capacitor): Uses @capacitor/haptics
 * - Web (Android Chrome): Uses Vibration API
 * - Fallback: No-op (iOS Safari has no Vibration API — only native gets haptics)
 */
export async function lightImpact(): Promise<void> {
  try {
    if (isNativePlatform()) {
      const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
      await Haptics.impact({ style: ImpactStyle.Light });
    } else if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(10);
    }
  } catch (error) {
    // Haptics are an optional enhancement — never crash, but log in dev
    if (import.meta.env.DEV) {
      console.warn('[haptics] lightImpact failed:', error);
    }
  }
}
